import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { Container } from '@mui/material';
import useCompetitionStore from 'store/competitionStore';
import useCompetition from 'hooks/useCompetition';
import Page from 'components/system/Page';
import CompetitionHeader from 'components/pages/Competition/CompetitionHeader/CompetitionHeader';
import CompetitionLoader from 'components/pages/Competition/ContentLoader/CompetitionLoader';
import CompetitionTabs from 'components/pages/Competition/CompetitionTabs/CompetitionTabs';
import { CompetitionPageStyles } from 'components/pages/Competition/competitionPage.styles';
import CompetitionPageMobileView from 'components/pages/Competition/CompetitionPageMobileView';
import useJoinedCompetitions from 'hooks/useJoinedCompetitions';
import withSeo from 'components/hoc/withSeo';

const CompetitionPage = ({ isMobile, isAppLoaded }) => {
  const { id: competitionId } = useParams();
  useJoinedCompetitions();
  useCompetition(competitionId);

  const { isLoading: isCompetitionLoading, details: competition } = useCompetitionStore((state) => ({
    isLoading: state.competition.isLoading,
    details: state.competition.details,
  }));
  const definitionLink = useMemo(() => competition?.definitionLink, [competition]);
  const rulesLink = useMemo(() => competition?.rulesLink, [competition]);
  const isLeaderboardVisible = useMemo(() => competition?.isLeaderboardVisible, [competition]);

  if ((isCompetitionLoading || competition?.competitionId !== competitionId)) {
    return (<CompetitionLoader isMobile={isMobile} />);
  }

  return !isMobile ? (
    <Container>
      <Page sx={CompetitionPageStyles}>
        <CompetitionHeader
          competition={competition}
          competitionId={competitionId}
        />
        <CompetitionTabs
          definitionLink={definitionLink}
          rulesLink={rulesLink}
          isLeaderboardVisible={isLeaderboardVisible}
        />
      </Page>
    </Container>
  ) : (
    <CompetitionPageMobileView
      isMobile={isMobile}
      isAppLoaded={isAppLoaded}
      name={competition?.name}
      start={competition?.start}
      competition={competition}
      competitionId={competitionId}
    />
  );
};

export default withSeo(CompetitionPage);
